"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openWithdrawSidePane = exports.openSidePane = exports.openRetailSendReceiveSidePane = exports.openRetailFiatSidePane = exports.openReportsSidePane = exports.openReportBlockTradeSidePane = exports.openKYC_ManualSidePane = exports.openKYC_JumioSidePane = exports.openKYC_IMSidePane = exports.openKYC_IMLegacySidePane = exports.openKYC_AGSidePane = exports.openKYCSidePane = exports.openDepositSidePane = exports.openApiKeysSidePane = exports.openAdvancedOrderSidePane = exports.closeWithdrawSidePane = exports.closeSidePane = exports.closeRetailSendReceiveSidePane = exports.closeReportsSidePane = exports.closeReportBlockTradeSidePane = exports.closeKYC_JumioSidePane = exports.closeKYCSidePane = exports.closeDepositSidePane = exports.closeApiKeysSidePane = exports.closeAdvancedOrderSidePane = exports.OPEN_SIDE_PANE = exports.CLOSE_SIDE_PANE = void 0;
var _sidePanesConstants = require("../../constants/sidePanesConstants");
var CLOSE_SIDE_PANE = exports.CLOSE_SIDE_PANE = 'CLOSE_SIDE_PANE';
var OPEN_SIDE_PANE = exports.OPEN_SIDE_PANE = 'OPEN_SIDE_PANE';
var openSidePane = exports.openSidePane = function openSidePane(pane, props) {
  return {
    type: OPEN_SIDE_PANE,
    payload: {
      pane: pane,
      sidePaneProps: props
    }
  };
};
var closeSidePane = exports.closeSidePane = function closeSidePane(pane) {
  return {
    type: CLOSE_SIDE_PANE,
    payload: pane
  };
};
var openAdvancedOrderSidePane = exports.openAdvancedOrderSidePane = function openAdvancedOrderSidePane() {
  return openSidePane(_sidePanesConstants.SIDE_PANES.ADVANCED_ORDER);
};
var closeAdvancedOrderSidePane = exports.closeAdvancedOrderSidePane = function closeAdvancedOrderSidePane() {
  return closeSidePane(_sidePanesConstants.SIDE_PANES.ADVANCED_ORDER);
};
var openReportBlockTradeSidePane = exports.openReportBlockTradeSidePane = function openReportBlockTradeSidePane() {
  return openSidePane(_sidePanesConstants.SIDE_PANES.ADVANCED_ORDER);
};
var closeReportBlockTradeSidePane = exports.closeReportBlockTradeSidePane = function closeReportBlockTradeSidePane() {
  return closeSidePane(_sidePanesConstants.SIDE_PANES.REPORT_BLOCK_TRADE);
};
var openReportsSidePane = exports.openReportsSidePane = function openReportsSidePane(index) {
  return openSidePane(_sidePanesConstants.SIDE_PANES.REPORTS, index);
};
var closeReportsSidePane = exports.closeReportsSidePane = function closeReportsSidePane() {
  return closeSidePane(_sidePanesConstants.SIDE_PANES.REPORTS);
};
var openDepositSidePane = exports.openDepositSidePane = function openDepositSidePane(product) {
  return openSidePane(_sidePanesConstants.SIDE_PANES.DEPOSITS, {
    product: product
  });
};
var closeDepositSidePane = exports.closeDepositSidePane = function closeDepositSidePane() {
  return closeSidePane(_sidePanesConstants.SIDE_PANES.DEPOSITS);
};
var openWithdrawSidePane = exports.openWithdrawSidePane = function openWithdrawSidePane(product) {
  return openSidePane(_sidePanesConstants.SIDE_PANES.WITHDRAWS, {
    product: product
  });
};
var closeWithdrawSidePane = exports.closeWithdrawSidePane = function closeWithdrawSidePane() {
  return closeSidePane(_sidePanesConstants.SIDE_PANES.WITHDRAWS);
};
var openApiKeysSidePane = exports.openApiKeysSidePane = function openApiKeysSidePane() {
  return openSidePane(_sidePanesConstants.SIDE_PANES.API_KEYS);
};
var closeApiKeysSidePane = exports.closeApiKeysSidePane = function closeApiKeysSidePane() {
  return closeSidePane(_sidePanesConstants.SIDE_PANES.API_KEYS);
};
var openKYCSidePane = exports.openKYCSidePane = function openKYCSidePane() {
  return openSidePane(_sidePanesConstants.SIDE_PANES.KYC);
};
var openKYC_IMSidePane = exports.openKYC_IMSidePane = function openKYC_IMSidePane() {
  return openSidePane(_sidePanesConstants.SIDE_PANES.KYC_IM);
};
var openKYC_AGSidePane = exports.openKYC_AGSidePane = function openKYC_AGSidePane(level) {
  return openSidePane(_sidePanesConstants.SIDE_PANES.KYC_AGForm, level);
};
var openKYC_IMLegacySidePane = exports.openKYC_IMLegacySidePane = function openKYC_IMLegacySidePane() {
  return openSidePane(_sidePanesConstants.SIDE_PANES.KYC_IMLegacy);
};
var openKYC_JumioSidePane = exports.openKYC_JumioSidePane = function openKYC_JumioSidePane() {
  return openSidePane(_sidePanesConstants.SIDE_PANES.KYC_Jumio);
};
var openKYC_ManualSidePane = exports.openKYC_ManualSidePane = function openKYC_ManualSidePane() {
  return openSidePane(_sidePanesConstants.SIDE_PANES.KYC_Manual);
};
var closeKYCSidePane = exports.closeKYCSidePane = function closeKYCSidePane() {
  return closeSidePane(_sidePanesConstants.SIDE_PANES.KYC);
};
var closeKYC_JumioSidePane = exports.closeKYC_JumioSidePane = function closeKYC_JumioSidePane() {
  return closeSidePane(_sidePanesConstants.SIDE_PANES.KYC_Jumio);
};
var openRetailSendReceiveSidePane = exports.openRetailSendReceiveSidePane = function openRetailSendReceiveSidePane(isSend, product) {
  return openSidePane(_sidePanesConstants.SIDE_PANES.RETAIL_SEND_RECEIVE, {
    isSend: isSend,
    product: product
  });
};
var closeRetailSendReceiveSidePane = exports.closeRetailSendReceiveSidePane = function closeRetailSendReceiveSidePane() {
  return closeSidePane(_sidePanesConstants.SIDE_PANES.RETAIL_SEND_RECEIVE);
};
var openRetailFiatSidePane = exports.openRetailFiatSidePane = function openRetailFiatSidePane(isSend, product, isDepositDisabled, isWithdrawDisabled) {
  return openSidePane(_sidePanesConstants.SIDE_PANES.RETAIL_FIAT, {
    isSend: isSend,
    product: product,
    isDepositDisabled: isDepositDisabled,
    isWithdrawDisabled: isWithdrawDisabled
  });
};